__turbopack_context__.v({
  "Root": "DWBE4q_Root",
  "Root--2": "DWBE4q_Root--2",
  "Root--3": "DWBE4q_Root--3",
  "Root--4": "DWBE4q_Root--4",
  "Root--FullHeight": "DWBE4q_Root--FullHeight",
  "Root--NoPaddingBottom": "DWBE4q_Root--NoPaddingBottom",
  "Root--Theme-minimal": "DWBE4q_Root--Theme-minimal",
  "Root--WithGap": "DWBE4q_Root--WithGap",
  "Root--WithGapLarge": "DWBE4q_Root--WithGapLarge",
  "Root--WithGapXLarge": "DWBE4q_Root--WithGapXLarge",
  "skeleton-loading": "DWBE4q_skeleton-loading",
});
